import { render, staticRenderFns } from "./scroll.vue?vue&type=template&id=4098e010&scoped=true&"
import script from "./scroll.vue?vue&type=script&lang=js&"
export * from "./scroll.vue?vue&type=script&lang=js&"
import style0 from "./scroll.vue?vue&type=style&index=0&id=4098e010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4098e010",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4098e010')) {
      api.createRecord('4098e010', component.options)
    } else {
      api.reload('4098e010', component.options)
    }
    module.hot.accept("./scroll.vue?vue&type=template&id=4098e010&scoped=true&", function () {
      api.rerender('4098e010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/richText/scroll.vue"
export default component.exports